<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="coord?.tel" 
 
[label]="step12.gettel"
[type]="'text'" [rule]="'pattern_8|minSize_10|maxSize_15'"
[errorMessage]="{'pattern' : 'ctr_31'}"
[name]="getUid()+'_SepAtt_tel'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="coord?.poste" 
 
[label]="step12.getposte"
[type]="'text'" [rule]="'maxSize_20'"
[name]="getUid()+'_SepAtt_poste'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="coord?.fax" 
 
[label]="step12.getfax"
[type]="'text'" [rule]="'pattern_8|minSize_10|maxSize_15'"
[errorMessage]="{'pattern' : 'ctr_32'}"
[name]="getUid()+'_SepAtt_fax'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="coord?.mel" 
 
[label]="step12.getmel"
[type]="'text'" [rule]="'pattern_1|maxSize_200'"
[errorMessage]="{'pattern' : 'ctr_33'}"
[name]="getUid()+'_SepAtt_mel'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="coord?.url" 
 
[label]="step12.geturl"
[type]="'text'" [rule]="'maxSize_200|pattern_33'"
[errorMessage]="{'pattern' : 'ctr_34'}"
[name]="getUid()+'_SepAtt_url'">
</app-form-input>
